import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { openDialog } from "../../store/actions";

interface IProps {
  allianceId: number;
  name: string;
  classes?: string;
}

const AllianceInfoLink = ({
  allianceId,
  name,
  classes
}: IProps) => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  const dispatch = useDispatch();

  return (
    <a
      ref={linkRef}
      onClick={event => dispatch(openDialog({
        name: "AllianceInfo",
        header: name,
        subHeader: "Alliance",
        elementRef: linkRef.current,
        clear: true,
        event,
        checkNotReload: (dialogOptions: any) => dialogOptions.allianceId === allianceId,
        allianceId
      }))}
      className={`link ${classes || "grey"}`}
    >
      {name}
    </a>
  )
}

export default AllianceInfoLink;
